import { WeekBase } from '../../shared/models/week-base';

/**
 * MLB Week.
 * - Simple ascending sort by SortOrder, then home team abbreviation (base default).
 * - Series array initialized via WeekBase.
 */
export class MlbWeek extends WeekBase {
  constructor(division: string) {
    super(division);
  }
}
